import { Routes, Route } from 'react-router-dom';
import Nav from './components/Nav';
import Startseite from './pages/Startseite';
import Galerie from './pages/Galerie';
import Buchung from './pages/Buchung';
import Cafe from './pages/Cafe';
import Referenzen from './pages/Referenzen';
import AdminPage from './pages/AdminPage';

export default function App() {
  return (
    <>
      <Nav />
      <Routes>
        <Route path="/" element={<Startseite />} />
        <Route path="/galerie" element={<Galerie />} />
        <Route path="/cafe" element={<Cafe />} />
        <Route path="/referenzen" element={<Referenzen />} />
        <Route path="/buchung" element={<Buchung />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
    </>
  );
}
